import { Component, OnInit } from '@angular/core';
import { ValidationService } from '../validation.service';
import { SnackbarService } from '../snackbar.service';
import { HttpService } from '../http.service';
import { StorageService } from '../storage.service';
import {  ActivatedRoute, Router } from '@angular/router';
import { EventService } from '../event.service';

import {Messages} from '../constants/messages'
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  credentials: any = {
    email_id: '',
    password: '',
    from: 'web'
  };

  messages = new Messages();
  loginUrl: any;
  inputType: boolean = false;
  constructor(private snackbar: SnackbarService, private valid: ValidationService, private http: HttpService,
              private storage: StorageService, private route: Router, private event: EventService, private router: ActivatedRoute) {
    const access_token = this.storage.getFromCookie('access_token');
    const returnUrl = this.router.snapshot.queryParams['returnUrl'];
    if (access_token && returnUrl === undefined) {
      this.route.navigateByUrl('welcome');
    }
  }

  ngOnInit() {
     this.valid.logout();
    this.loginUrl = this.router.snapshot.queryParams['returnUrl'] || 'welcome';
  }

  validate(Obj): boolean {
    let valid: boolean = true;
    if (!this.valid.isEmpty(Obj.email_id) && !this.valid.isEmpty(Obj.password)) {
      if (!this.valid.isEmail(Obj.email_id)) {
        this.snackbar.openSnackBar(this.messages.LOGIN.VALIDATION.INVALID_EMAIL, '','err');
        valid = false;
      } else if (!this.valid.isPassword(Obj.password)) {
        this.snackbar.openSnackBar(this.messages.LOGIN.VALIDATION.PASSWORD_LENGTH, '','err');
        valid = false;
      }

    } else {
      this.snackbar.openSnackBar(this.messages.LOGIN.VALIDATION.NO_EMPTY, '', 'err');
      valid = false;
    }
    return valid;

  }

  login() {
    const valid = this.validate(this.credentials);
    if (valid) {
      this.http.login('carrier_user/signin', this.credentials).subscribe(
        (data: any) => {
          if ( data.statusCode === 200) {
            this.storage.setCookie('access_token', data.data.accessToken);
            this.storage.setCookie('carrier_id', data.data.carriers[0]._id);
            this.storage.setCookie('user_name', data.data.name);
            this.storage.setToLocalStorage('userId', JSON.stringify(data.data._id));
            this.storage.setToLocalStorage('carriers', JSON.stringify(data.data.carriers));
            this.storage.setToLocalStorage('roles', JSON.stringify(data.data.roles));
            this.storage.setToLocalStorage('country',JSON.stringify(data.data.country));
            this.snackbar.openSnackBar(this.messages.LOGIN.SUCCESS.LOGIN_SUCCESS, '');
            this.http.refreshAccessToken();
            this.getCity();
            this.event.setAccessTokenChanges(true);
            this.route.navigateByUrl(this.loginUrl);
          }
        },
        (err: any) => {
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      );
    }
  }

  getCity() {
    this.http.get('city/all').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.storage.setToLocalStorage('cities', JSON.stringify(data.data));
        }
      },
      (err: any) => {
        console.log('err-=', err);
        this.valid.logout();
      }
    );
  }
  togglePasswordVisibility() {
    this.inputType = !this.inputType;
  }
}
